import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { Row, Col } from 'reactstrap';

import { TOLL_EXTRAORDINARY_ASSIGNMENT_PATH } from '../../../../config/paths';
import {
  getTollExtraordinaryAssignment,
  clearTollExtraordinaryAssignment,
} from '../../../../actions';

import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';

import Content from '../../../layout/Content';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';

import TollExtraordinaryAssignmentBasicInformationResource from './resources/TollExtraordinaryAssignmentBasicInformationResource';
import TollExtraordinaryAssignmentToolBar from './TollExtraordinaryAssignmentToolBar';

export const TollExtraordinaryAssignment = ({
  breadcrumbs,
  dispatchGetTollExtraordinaryAssignment,
  dispatchClearTollExtraordinaryAssignment,
  match: {
    params: { id: tollExtraordinaryAssignmentId },
  },
  loading,
  tollExtraordinaryAssignment,
}) => {
  useLayoutEffect(() => {
    dispatchGetTollExtraordinaryAssignment({ tollExtraordinaryAssignmentId });

    return () => dispatchClearTollExtraordinaryAssignment();
  }, []);

  let content;
  let toolbar;

  if (loading) {
    content = <Loader />;
  } else if (tollExtraordinaryAssignment.isEmpty()) {
    content = (
      <NoDataResource returnPage={TOLL_EXTRAORDINARY_ASSIGNMENT_PATH} />
    );
  } else {
    const tollExtraordinaryAssignmentJson = tollExtraordinaryAssignment.toJS();

    content = (
      <Row>
        <Col md={6}>
          <h3>Información Básica</h3>
          <TollExtraordinaryAssignmentBasicInformationResource
            {...tollExtraordinaryAssignmentJson}
          />
        </Col>
      </Row>
    );

    toolbar = (
      <TollExtraordinaryAssignmentToolBar
        tollExtraordinaryAssignmentId={tollExtraordinaryAssignmentJson.id}
      />
    );
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      toolbar={toolbar}
      title="Peaje Extraordinario Asignado"
      content={content}
    />
  );
};

TollExtraordinaryAssignment.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchGetTollExtraordinaryAssignment: PropTypes.func.isRequired,
  dispatchClearTollExtraordinaryAssignment: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  tollExtraordinaryAssignment: PropTypes.instanceOf(Immutable.Map).isRequired,
};

TollExtraordinaryAssignment.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchGetTollExtraordinaryAssignment: getTollExtraordinaryAssignment,
  dispatchClearTollExtraordinaryAssignment: clearTollExtraordinaryAssignment,
};

const mapStateToProps = ({ RouteUnit }) => ({
  breadcrumbs: [
    ...RouteUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Peajes Extraordinarios Asignados',
      href: TOLL_EXTRAORDINARY_ASSIGNMENT_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],

  tollExtraordinaryAssignment: RouteUnit.TollExtraordinaryAssignment.getIn([
    'current',
    'content',
  ]),

  loading: !RouteUnit.TollExtraordinaryAssignment.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TollExtraordinaryAssignment);
